import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`

 *,
  *::after,
  *::before {
    margin: 0;
    box-sizing: border-box;
  }

body{
font-family: 'Poppins', sans-serif;
display: flex;
width: 100%;
max-width: 100%;
}

.container {
    margin: 0 auto;
    width: 85%;

    @media (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
      width: 100%;
      margin: 0 auto;
      max-width: 100%;
      padding: 15px;
    }
  }

  .site-main{
    width: 100%;
    max-width: 100%;
    min-height: 700px; 
  }

img{
max-width: 100%;
}
`;

export default GlobalStyles;
